// 循环模式
export enum LoopMode {
  none = 'none',
  yoyo = 'yoyo',
  repeat = 'repeat',
}

// 运行状态
export enum MotionState {
  play = 'play',
  pause = 'pause',
  continue = 'continue',
}